import React, { useEffect } from 'react'
import { useSessionContext } from 'session'
import { DuplicatesContent } from 'components'

export const DuplicatesPage: React.FC = () => {
  const { changeModuleName, changeUniqueId } = useSessionContext()

  useEffect(() => {
    changeModuleName('Process Duplicate Sheets')
    changeUniqueId('')
  }, [changeModuleName])
  return (
      <DuplicatesContent/>
  )
}
